// Cliente minimo de PocketBase.
//
// La landing es estatica y habla DIRECTO con PocketBase (pb.blockchains.tf): no hay
// backend propio. Se usa `fetch` en vez del SDK oficial porque solo hacen falta tres
// llamadas y no vale traer una dependencia entera para eso.
//
// La logica que no puede vivir en el navegador (honeypot, IP real, upsert por correo)
// esta en el hook del servidor: `pocketbase/pb_hooks/leads.pb.js`.

const BASE = (process.env.REACT_APP_PB_URL || "").replace(/\/$/, "");

const LEADS = `${BASE}/api/collections/leads/records`;
const STAFF_AUTH = `${BASE}/api/collections/staff/auth-with-password`;

export class PbError extends Error {
  constructor(status, payload) {
    super(payload?.message || `HTTP ${status}`);
    this.status = status;
    this.payload = payload;
  }
}

async function req(url, options = {}) {
  const res = await fetch(url, {
    ...options,
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
  });
  const payload = await res.json().catch(() => null);
  if (!res.ok) throw new PbError(res.status, payload);
  return payload;
}

/** Alta de un lead. Publica: la regla `create` de la coleccion esta abierta a proposito. */
export function createLead(data) {
  return req(LEADS, { method: "POST", body: JSON.stringify(data) });
}

/** Login del panel /admin contra la coleccion `staff` (NUNCA con el superuser). */
export async function loginStaff(email, password) {
  const r = await req(STAFF_AUTH, {
    method: "POST",
    body: JSON.stringify({ identity: email, password }),
  });
  return r.token;
}

/**
 * Trae todos los leads. PocketBase pagina, asi que se recorren las paginas hasta el
 * final: con un `perPage` fijo, en cuanto pasen de 500 la lista mentiria por lo bajo.
 */
export async function listLeads(token) {
  const headers = { Authorization: token };
  const out = [];
  let page = 1;
  for (;;) {
    const r = await req(
      `${LEADS}?perPage=200&page=${page}&sort=-created`,
      { headers },
    );
    out.push(...r.items);
    if (page >= r.totalPages || r.items.length === 0) break;
    page += 1;
  }
  return out;
}

const CSV_FIELDS = [
  "created", "updated", "business_name", "email", "whatsapp", "business_type",
  "city", "terminals", "consent", "language", "utm_source", "utm_medium",
  "utm_campaign", "referrer", "ip",
];

/**
 * Una celda que empieza con = + - @ (o tab/CR) la ejecuta Excel/Sheets al abrir el
 * archivo. `business_name` y `city` los escribe cualquiera desde el formulario publico,
 * asi que se les antepone una comilla simple para que entren como texto.
 */
function safeCell(value) {
  const s = value === null || value === undefined ? "" : String(value);
  const prefixed = /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
  return `"${prefixed.replace(/"/g, '""')}"`;
}

export function leadsToCsv(leads) {
  const rows = [CSV_FIELDS.join(",")];
  for (const l of leads) rows.push(CSV_FIELDS.map((f) => safeCell(l[f])).join(","));
  // BOM para que Excel abra los acentos bien.
  return `﻿${rows.join("\r\n")}`;
}
